<mat-card class="deal-card mat-elevation-z2">
    <mat-card-content>
        <div *ngIf="isCustomer" class="d-flex flex-column justify-content-start name">
            <p>
                <mat-icon *ngIf="deal.statusId === 1; else complete">directions_car</mat-icon>
                <ng-template #complete>
                    <mat-icon class="complete">verified</mat-icon>
                </ng-template>
                {{ deal.dealershipName }}
            </p>
        </div>
        <div *ngIf="!isCustomer" class="d-flex flex-column justify-content-start name">
            <p>{{ deal.buyer?.firstName }} {{ deal.buyer?.lastName }}</p>
        </div>
        <div *ngIf="deal.coBuyer.firstName" class="d-flex justify-content-start">
            <p><strong>Co-Buyer:</strong>{{ deal.coBuyer.firstName }} {{ deal.coBuyer.lastName }}</p>
        </div>
        <div class="d-flex justify-content-start dl">
            <p><strong>Deal:</strong>{{ deal.dealerDealNumber }}</p>
        </div>
        <div class="d-flex justify-content-start">
            <p><strong>Salesperson:</strong>{{ deal.salesperson.firstName }} {{ deal.salesperson.lastName }}</p>
        </div>
        <div class="d-flex justify-content-start">
            <p><strong>ID:</strong>{{ deal.dealId }}</p>
        </div>
        <div class="d-flex justify-content-start">
            <p><strong>VIN:</strong>{{ deal.vehicle.vin }}</p>
        </div>
        <div class="d-flex justify-content-start">
            <p><strong>Stock:</strong>{{ deal.vehicle.stockNumber }}</p>
        </div>
        <div class="d-flex justify-content-start">
            <p>
                <strong>Vehicle:</strong><span *ngIf="deal.vehicle.year > 0">{{ deal.vehicle.year }}</span> {{ deal.vehicle.make }} {{ deal.vehicle.model }}
            </p>
        </div>
    </mat-card-content>
    <div class="button-container" [class.no-cobuyer]="!deal.coBuyer.firstName">
        <a mat-button [routerLink]="dealUrl">
            <span class="button-label">{{ actionName }}</span>
            <span class="button-icon-wrapper">
                <mat-icon aria-hidden="true">arrow_right_alt</mat-icon>
            </span>
        </a>
    </div>
</mat-card>
